module.exports = __webpack_public_path__ + "img/icon-32-ic-androidbox.a959476f.svg";